import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import css from './AboutPage.module.css';
import { isLocaleGreek } from '../../util/genericHelpers';

function SectionOurStory() {
  return (
    <div className={css.ourStoryContainer}>
      <div className={css.contentWidth}>
        <div className={css.ourStoryContent}>
          <h1>
            <FormattedMessage id="AboutPage.ourStoryHeading" />
          </h1>
          <p>
            <FormattedMessage id="AboutPage.ourStorydescription" />
          </p>
        </div>
      </div>
    </div>
  );
}

export default SectionOurStory;
